import { useMemo } from "react";
import { SelectWithLabel, SelectOption } from "newui/components/ui/InputWithLabel";
import { useFormikFieldState } from "newui/components/ui/CommonSelects/useFormikField";
import { useFormikContext } from "formik";

interface YearCompletedProps {
  name: string;
  defaultValue?: string | number;
  label?: string;
  required?: boolean;
  testId?: string;
}

export const YearCompleted: React.FC<YearCompletedProps> = ({
  name,
  label = "Year Complete",
  required = true,
  testId,
  defaultValue,
}) => {
  const formik = useFormikFieldState(name);
  const { setFieldValue } = useFormikContext();

  const options = useMemo(() => {
    const currentYear = new Date().getFullYear() + 5;
    const startYear = currentYear - 15;
    const result: SelectOption[] = [];
    for (let year = currentYear; year >= startYear; year--) {
      result.push({ value: year.toString(), label: year.toString() });
    }
    return result;
  }, []);

  const selectedValue = useMemo(() => {
    if (!defaultValue) return null;
    return options.find((o) => o.value === defaultValue.toString()) ?? null;
  }, [defaultValue, options]);

  const handleChange = (selected: SelectOption | SelectOption[] | null) => {
    formik.markTouched();
    const value = selected && !Array.isArray(selected) ? selected.value : "";
    setFieldValue(name, value, true);
  };

  return (
    <SelectWithLabel
      label={label}
      required={required}
      options={options}
      testId={testId}
      name={name}
      value={selectedValue}
      hasError={formik.hasError}
      errorText={formik.errorText}
      onChange={handleChange}
    />
  );
};
